import { RiskEvaluation } from "@/_models/risk-evaluation.model";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import {
    AssignedItemMeta,
    AssignedItemMetaService,
    EMPTY_ASSIGNED_ITEM_META,
} from "@/_services/assigned-item-meta.service";
import { listItemTitle } from "@/_utility/list-item-title.util";
import { RECORD_TYPE_BADGES } from "@/_utility/record-type-badge.util";
import { AssignedItemMetaComponent } from "../assigned-item-meta/assigned-item-meta.component";
import { Component, Input, OnChanges } from "@angular/core";
import { TagModule } from "primeng/tag";

@Component({
    selector: "app-risk-evaluation-task-card",
    standalone: true,
    imports: [SharedComponentsModule, TagModule, AssignedItemMetaComponent],
    templateUrl: "./risk-evaluation-task-card.component.html",
    styleUrls: [
        "./risk-evaluation-task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class RiskEvaluationTaskCardComponent implements OnChanges {
    @Input() riskEvaluation: RiskEvaluation;

    badge = RECORD_TYPE_BADGES.riskEvaluation;
    title: string = this.badge.untitledTitle;
    meta: AssignedItemMeta = EMPTY_ASSIGNED_ITEM_META;

    constructor(private metaService: AssignedItemMetaService) {}

    ngOnChanges(): void {
        this.title = listItemTitle(
            this.riskEvaluation,
            this.badge.untitledTitle,
        );
        this.meta = this.metaService.forRiskEvaluation(this.riskEvaluation);
    }
}
